import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  GymDay,
  OpeningTimeRange,
  OpeningTimeSentinel,
} from 'src/app/model/opening-hours';
import { OpeningTimeValue } from '../opening-time-editor/opening-time-editor.component';

@Component({
  selector: 'gymfinder-opening-hour',
  templateUrl: './opening-hour.component.html',
  styleUrls: ['./opening-hour.component.scss'],
  standalone: false,
})
export class OpeningHourComponent {
  @Input()
  day: GymDay;

  /** Override the displayed label (e.g. "All days"). Falls back to formatted day name. */
  @Input()
  label: string | undefined;

  @Input()
  editMode: boolean;

  @Input()
  set value(val: OpeningTimeRange[] | OpeningTimeSentinel | undefined) {
    this.editorValue = this.toEditorValue(val);
  }

  @Output()
  valueChange = new EventEmitter<OpeningTimeRange[] | OpeningTimeSentinel>();

  editorValue: OpeningTimeValue = { kind: 'not-available' };

  formatDay(day: GymDay): string {
    if (day === 'publicHoliday') return 'Public Holiday';
    return day.charAt(0).toUpperCase() + day.slice(1);
  }

  onEditorValueChange(val: OpeningTimeValue) {
    this.editorValue = val;
    switch (val.kind) {
      case 'not-available':
        this.valueChange.emit('NOT_AVAILABLE');
        break;
      case 'closed':
        this.valueChange.emit('CLOSED_24_HOURS');
        break;
      case 'open24':
        this.valueChange.emit('OPEN_24_HOURS');
        break;
      case 'ranges':
        this.valueChange.emit(val.ranges);
        break;
    }
  }

  private toEditorValue(
    val: OpeningTimeRange[] | OpeningTimeSentinel | undefined
  ): OpeningTimeValue {
    if (Array.isArray(val)) {
      return { kind: 'ranges', ranges: val };
    }
    switch (val) {
      case 'CLOSED_24_HOURS':
        return { kind: 'closed' };
      case 'OPEN_24_HOURS':
        return { kind: 'open24' };
      case 'NOT_AVAILABLE':
      default:
        return { kind: 'not-available' };
    }
  }
}
